// array of semantic colors, including legacy colors; this is mainly used for propTypes
// update when new colors are added
export var bombasColors = [
    'white',
    'black',
    'offwhite',
    'grey20',
    'grey40',
    'grey60',
    'grey80',
    'blue',
    'green',
    'red',
    'bombasBlue',
    'bombasSeafoam',
    'bombasYellow',
    'bombasRed',
    'bombasCream',
    'bombasGreen',
    'transparent'
];
// a map of semantic colors to its respective design token; it includes legacy colors like bombasBlue
// update when new colors are added
export var bombasColorsToToken = {
    white: '--white',
    black: '--black',
    offwhite: '--offwhite',
    grey20: '--grey-20',
    grey40: '--grey-40',
    grey60: '--grey-60',
    grey80: '--grey-80',
    blue: '--blue-60',
    green: '--green-50',
    red: '--red-40',
    bombasBlue: '--blue-60',
    bombasSeafoam: '--green-40',
    bombasYellow: '--yellow-50',
    bombasRed: '--red-40',
    bombasCream: '--offwhite',
    bombasGreen: '--green-50'
};
// Semantic token mappings by theme to hexcode
export var themeTokensToHexMap = {
    legacy: {
        '--white': '#ffffff',
        '--black': '#030302',
        '--offwhite': '#f8f7f7',
        '--grey-20': '#f3f3f2',
        '--grey-40': '#dcdbd9',
        '--grey-60': '#585653',
        '--grey-80': '#333130',
        '--blue-60': '#2e4366',
        '--green-40': '#31aab7',
        '--green-50': '#098750',
        '--red-40': '#e0563e',
        '--yellow-50': '#fdf185'
    },
    '2025-rebrand': {
        '--white': '#ffffff',
        '--black': '#030302',
        '--offwhite': '#f8f8f4',
        '--grey-20': '#f1f1ee',
        '--grey-40': '#eaeadf',
        '--grey-60': '#5c5b51',
        '--grey-80': '#312b2b',
        '--blue-60': '#223859',
        '--green-40': '#b6c498',
        '--green-50': '#098750',
        '--red-40': '#e0563e',
        '--yellow-50': '#e8bc44'
    }
};
